import { render, staticRenderFns } from "./ExpiredGhostCardNotification.vue?vue&type=template&id=d4774fb8&scoped=true&"
import script from "./ExpiredGhostCardNotification.vue?vue&type=script&lang=js&"
export * from "./ExpiredGhostCardNotification.vue?vue&type=script&lang=js&"
import style0 from "./ExpiredGhostCardNotification.vue?vue&type=style&index=0&id=d4774fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4774fb8",
  null
  
)

export default component.exports